import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Banner from "../../../../../components/layout/ui/Banner";
import { setColor } from "../../../../../assets/styles/styles";
import Typography from "../../../../../components/common/text/Typography";
import ToggleSwitch from "../../../../../components/common/switchToggle/ToggleSwitch";
import Modal from "../../../components/Modal";
import JsonViewerModal from "../../vanityLinks/components/JsonViewerModal";
import Button from "../../../../../components/common/button/Button";
import Dropdown from "../../../../../components/common/inputDropdown/Dropdown";
import { getUnityPopups } from "../../../../../api/ClientsTagController";
import { CACHE_QUERY_OPTIONS } from "../../../../../constants";

const CreatePopup = ({ tagPopupState, setTagPopupState, bannerType, handleSubmit }) => {
    const [isJsonEditorOpen, setIsJsonEditorOpen] = useState(false);
    const [jsonEditorValue, setJsonEditorValue] = useState("");
    const [jsonEditorField, setJsonEditorField] = useState("");
    const [jsonEditorIndex, setJsonEditorIndex] = useState(0);

    const [successMessageBanner, setSuccessMessageBanner] = useState("");

    // const [buttonDisabled, setButtonDisabled] = useState(true);

    const navigate = useNavigate();

    const updateTagPopupState = (index, key, value) => {
        setTagPopupState((prevState) => {
            const newPopups = [...prevState];
            newPopups[index] = { ...newPopups[index], [key]: value };

            return newPopups;
        });
    };

    const addNewPopup = () => {
        setTagPopupState((prevState) => [
            ...prevState,
            {
                unityPopupId: "",
                isEnabled: false,
                triggerType: "",
                triggerValue: {},
                metaData: {},
            },
        ]);
    };

    const handleJsonSave = (data) => {
        setTagPopupState((prev) => {
            const newPopups = [...prev];
            newPopups[jsonEditorIndex] = {
                ...newPopups[jsonEditorIndex],
                [jsonEditorField]: data,
            };
            return newPopups;
        });
        setIsJsonEditorOpen(false);
    };

    // get unity pop up
    const { data: popupData } = useQuery(["unityPopups"], getUnityPopups, {
        ...CACHE_QUERY_OPTIONS(),
    });

    useEffect(() => {
        if (bannerType === "SUCCESS") {
            setSuccessMessageBanner("Client Tag created successfully!");
            setTimeout(() => navigate("/console/client_tag"), 2000);
        } else if (bannerType === "ERROR") {
            setSuccessMessageBanner("Error creating Client Tag. Please try again.");
        }
    }, [bannerType, navigate]);

    return (
        <>
            <Banner
                width={"100%"}
                zIndex="1000"
                message={`${successMessageBanner}`}
                type={bannerType}
                openBanner={!!successMessageBanner}
                setOpenBanner={setSuccessMessageBanner}
                topDisplay
                showCloseButton
                gameScreen={false}
                top={"0px"}
                left={"0"}
            />
            <ModalContent>
                <GeneralContainer>
                    <Typography variant="h2PurpleHeading" margin={`1rem 0 0 0`} fontSize={"24px"}>
                        Step 2: Create Unity Popup
                    </Typography>
                    {tagPopupState.map((popup, index) => (
                        <div key={index} style={{ marginBottom: "2rem" }}>
                            <Typography variant="h3" margin={`1rem 0`}>
                                Popup {index + 1}
                            </Typography>
                            <Table>
                                <TableRow>
                                    <TableColumn>
                                        {/* <Label>Unity Popup ID</Label> */}
                                        {/* <InputBox
                                            type="text"
                                            id={`unityPopupId-${index}`}
                                            placeholder="Enter popup ID"
                                            value={popup.unityPopupId}
                                            onChange={(e) => updateTagPopupState(index, "unityPopupId", e.target.value)}
                                        /> */}
                                        <Dropdown
                                            key="popupDataInput"
                                            label="Unity Pop up*"
                                            items={
                                                popupData?.unityPopups?.map((item) => ({
                                                    ...item,
                                                    value: item.popupName,
                                                })) || []
                                            }
                                            selectedValue={popup.unityPopupId}
                                            setSelectedValue={(value) => {
                                                updateTagPopupState(
                                                    index,
                                                    "unityPopupId",
                                                    popupData?.unityPopups?.find((item) => item.popupName === value)
                                                        ?.unityPopupId || ""
                                                );
                                            }}
                                            placeholder="Select Unity Popup"
                                        />
                                    </TableColumn>
                                </TableRow>

                                <TableRow>
                                    <TableColumn>
                                        <Label>Is pop up enabled?</Label>
                                        <ToggleSwitch
                                            value={popup.isEnabled}
                                            onChange={(value) => updateTagPopupState(index, "isEnabled", value)}
                                        />
                                    </TableColumn>
                                </TableRow>

                                <TableRow>
                                    <TableColumn>
                                        <Dropdown
                                            key={`triggerType-${index}`}
                                            label="Popup trigger type"
                                            items={["room_load", "achievement", "dynamic_linkout"].map((value) => ({
                                                value,
                                            }))}
                                            selectedValue={popup.triggerType}
                                            setSelectedValue={(value) => {
                                                updateTagPopupState(index, "triggerType", value);
                                            }}
                                            placeholder="Select Trigger Type"
                                        />
                                    </TableColumn>
                                </TableRow>

                                {/* Popup trigger: List of room Id's 
                                Popup trigger: List of Achievements Id's 
                                Popup trigger: List of dynamic-linkout-objects (eg: "DynamicAssetId/InteractionPrefabName") */}
                                <TableRow>
                                    <TableColumn>
                                        {["dynamic_linkout", "room_load", "achievement"].includes(
                                            popup.triggerType
                                        ) && (
                                            <>
                                                <Label>
                                                    {popup.triggerType === "dynamic_linkout" && "Popup trigger value"}
                                                    {popup.triggerType === "room_load" &&
                                                        "Popup trigger value for room load"}
                                                    {popup.triggerType === "achievement" &&
                                                        "Popup trigger value for achievement"}
                                                </Label>
                                                <InputBox
                                                    type="text"
                                                    id={`triggerValue-${index}`}
                                                    placeholder="Enter triggervalue"
                                                    value={JSON.stringify(popup.triggerValue || {})}
                                                    onClick={() => {
                                                        setJsonEditorField("triggerValue");
                                                        setJsonEditorValue(
                                                            JSON.stringify(popup.triggerValue || {}, null, 2)
                                                        );
                                                        setJsonEditorIndex(index);
                                                        setIsJsonEditorOpen(true);
                                                    }}
                                                />
                                            </>
                                        )}
                                    </TableColumn>
                                </TableRow>

                                <TableRow>
                                    <TableColumn>
                                        <Label>Meta data</Label>
                                        <InputBox
                                            type="text"
                                            name={`metaData-${index}`}
                                            value={JSON.stringify(popup.metaData || {})}
                                            onClick={() => {
                                                setJsonEditorField("metaData");
                                                setJsonEditorValue(JSON.stringify(popup.metadata || {}, null, 2));
                                                setJsonEditorIndex(index);
                                                setIsJsonEditorOpen(true);
                                            }}
                                        />
                                    </TableColumn>
                                </TableRow>
                            </Table>
                        </div>
                    ))}
                    <TableRow>
                        <TableColumn>
                            <Button
                                variant="SmallButton"
                                buttonWidth="100%"
                                label="Add Another Popup"
                                onClick={addNewPopup}
                            />
                        </TableColumn>
                    </TableRow>
                    <TableRow>
                        <TableColumn>
                            <Button
                                variant="PinkButton"
                                buttonWidth="100%"
                                label="Finish Creating Client Tag"
                                onClick={async () => {
                                    await handleSubmit();
                                }}
                            />
                        </TableColumn>
                    </TableRow>
                </GeneralContainer>
            </ModalContent>

            {isJsonEditorOpen && (
                <Modal
                    isOpen={isJsonEditorOpen}
                    setIsOpen={setIsJsonEditorOpen}
                    children={
                        <JsonViewerModal
                            jsonEditorValue={jsonEditorValue}
                            handleJsonSave={handleJsonSave}
                            fieldName={jsonEditorField}
                            label={jsonEditorField}
                            closeModal={() => setIsJsonEditorOpen(false)}
                        />
                    }
                />
            )}
        </>
    );
};

export default CreatePopup;

const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    color: ${setColor.inputText};
`;

const GeneralContainer = styled.div`
    width: 80%;
    font-family: "Barlow-Regular", Helvetica;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: center;
    margin-top: 15px;
    @media (max-width: 768px) {
        font-size: 14px;
    }
`;

const Table = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1rem;
    border-radius: 5px;
    color: #fbfcff;
`;

const TableRow = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
`;

const TableColumn = styled.div`
    flex: 1;
    padding: 5px;
`;

const Label = styled.div`
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 10px;
`;

const InputBox = styled.input`
    padding: 10px;
    border: ${(props) => (props.errorMessage ? `1px solid ${setColor.errorColor}` : `1px solid ${setColor.grey1}`)};
    border-radius: 5px;
    color: ${setColor.inputText};
    margin: 0rem 0rem 0rem 0rem;
    width: ${(props) => (props.width ? props.width : "100%")};
    background-color: transparent;
    margin-bottom: ${(props) => (props.errorMessage ? "0.5rem" : "0rem")};
    &:disabled {
        background-color: ${setColor.grey1};
    }
`;

const TagsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;
`;

const Tag = styled.div`
    display: flex;
    align-items: center;
    background: ${setColor.grey1};
    border-radius: 16px;
    padding: 4px 12px;
    margin-right: 8px;
    margin-bottom: 8px;
`;

const RemoveButton = styled.button`
    margin-left: 8px;
    background: transparent;
    border: none;
    cursor: pointer;
    color: #d00;
    font-weight: bold;
`;
